module.exports = __webpack_public_path__ + "img/icon4.b109f176.png";